import { css, styled } from 'styled-components';

import { layoutHeaderMobileLinksHeight } from '#/layouts/Layout/Header/layoutHeaderConstants';
import { scrolledDownZeroVar } from '#/theme/scrolled';
import { colors, cssBreakpoints, gutterWidth, transition } from '#/theme/theme';

export const LayoutHeaderBottomSectionHolder = styled.div<{
  $isInSearchPage: boolean;
  $withScrolledTransition: boolean;
}>`
  display: flex;
  flex-direction: column;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    ${(props) =>
      props.$isInSearchPage
        ? css`
            transition: ${props.$withScrolledTransition &&
            `padding-top ${transition}`};
            padding-top: calc(
              ${[layoutHeaderMobileLinksHeight]}px *
                var(${scrolledDownZeroVar}, 1)
            );
          `
        : css`
            padding-top: ${layoutHeaderMobileLinksHeight}px;
          `};
  }
`;

export const LayoutHeaderDesktopSearchHolder = styled.div`
  padding: 16px ${gutterWidth / 2}px;
  background-color: ${colors.white};
  border-top: 1px solid ${colors.selectionGrey};

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;
export const LayoutHeaderProgressBarHolder = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 1;
`;

export const SearchRefinementsHolder = styled.div<{
  $hideOnMobile: boolean;
}>`
  ${(props) =>
    props.$hideOnMobile &&
    css`
      @media (max-width: ${cssBreakpoints.mdDown}) {
        display: none;
      }
    `}
`;
